/**
 * @generated SignedSource<<11b447b6998dde13d1f5aafa86c50eb1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type OrganizationCheckoutVersion = "stripe" | "stripe_acacia" | "%future added value";
export type UpgradeCheckoutVersionInput = {
  stripe_acacia?: UpgradeToStripeAcaciaInput | null;
  version: OrganizationCheckoutVersion;
};
export type UpgradeToStripeAcaciaInput = {
  discountIds: ReadonlyArray<string>;
};
export type UpgradeCheckoutVersionModalContentMutation$variables = {
  input: UpgradeCheckoutVersionInput;
};
export type UpgradeCheckoutVersionModalContentMutation$data = {
  readonly response: {
    readonly errors: ReadonlyArray<{
      readonly field: string;
      readonly message: string;
    }> | null;
    readonly node: {
      readonly checkoutVersion: OrganizationCheckoutVersion | null;
      readonly id: string;
      readonly stripeAccountId: string | null;
    } | null;
  };
};
export type UpgradeCheckoutVersionModalContentMutation = {
  response: UpgradeCheckoutVersionModalContentMutation$data;
  variables: UpgradeCheckoutVersionModalContentMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": "response",
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpgradeCheckoutVersionMutationResponse",
    "kind": "LinkedField",
    "name": "upgradeCheckoutVersion",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Organization",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "stripeAccountId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "checkoutVersion",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ValidationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "field",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UpgradeCheckoutVersionModalContentMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UpgradeCheckoutVersionModalContentMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "ab4c2d65a930ba6d6d0bb94ed7108467",
    "id": null,
    "metadata": {},
    "name": "UpgradeCheckoutVersionModalContentMutation",
    "operationKind": "mutation",
    "text": "mutation UpgradeCheckoutVersionModalContentMutation(\n  $input: UpgradeCheckoutVersionInput!\n) {\n  response: upgradeCheckoutVersion(input: $input) {\n    node {\n      id\n      stripeAccountId\n      checkoutVersion\n    }\n    errors {\n      field\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "2340ee4e0fbdcb005697e523e1e1fb59";

export default node;
